export const INIT = 'INIT'
export const UPDATE = 'UPDATE_INTRODUCTION'
